import React, { useState, useEffect } from "react";
import { Image, Col, Form, Row, Button } from "react-bootstrap";
import { TextField, FormControl, Select } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import SimpleReactLightbox from "simple-react-lightbox";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { Toggle } from "../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
//import { AmealioLoader } from "../../../Loader/AmealioLoader";
import moment from "moment";
import axios from "axios";
import {
  serverApi,
  videoUploadSize,
  imageUploadSize,
} from "../../../../config/Keys";
import Alert from "react-s-alert";
import Switch from "react-switch";
import MultipleImageUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import AlertDialogProgress from "../../../reusableComponents/allPopupReusable/DialogProgression";
import isEmpty from "../../../../store/validation/is-Empty";
import { vendor_update_events } from "../../../../store/actions/vendorOffersAndEventsAction";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

const validationSchema = yup.object({
  name: yup
    .string()
    .required("Event name is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  description: yup
    .string()
    .required("Description is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  start_date: yup.string().required("Start date is required"),
  start_time: yup.string().required("Start time is required"),
  end_date: yup.string().required("End date is required"),
  end_time: yup.string().required("End time is required"),
  // eventLink: yup
  //   .string()
  //   .matches(
  //     /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
  //     "Url is invalid"
  //   )
  //   .required("Please enter url"),

  terms_and_condition: yup
    .string()
    .required("Terms and condtion  is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
});

const VendorEditOnlineEvent = (props) => {
  //state
  let history = useHistory();
  const [loading, setLoading] = useState();
  const [checked, setChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [Video, setVideo] = useState(null);
  const [primaryOffer, setPrimaryOffer] = useState({ primaryOffer: false });
  const [active, setactive] = useState({ active: false });
  const markAsPrimary = (data) => (e) => {
    // setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
    if (data === false) {
      setPrimaryOffer({ primaryOffer: true });
      setactive({ active: true });
    } else {
      setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
    }
  };

  const thumbnail = true;

  const statusChange = (e) => {
    setactive({ active: !active.active });
  };

  const [state, setState] = useState({
    minAge: 18,
    restaurant_pictures: [],
    restaurant_pictures_new: [],
    restaurant_video: [],
    video_url: "",
    actionButton: false,
    progress: 0,

    link_code_different: false,
    link_code_same: false,
    casualDiningOnlineEventsYoutube: false,
    casualDiningOnlineEventsInstagram: false,
    casualDiningOnlineEventsFacebook: false,
    casualDiningOnlineEventsLinkdin: false,
    casualDiningOnlineEventsOthers: false,
    casualDiningOnlineEventsYoutubeArr: [],
    casualDiningOnlineEventsInstagramArr: [],
    casualDiningOnlineEventsFacebookArr: [],
    casualDiningOnlineEventsLinkdinArr: [],
    casualDiningOnlineEventsOthersArr: [],
    errors: {},
  });
  const selecthandleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };
  const toggleFunction = (e) => {
    // setChecked({ checked: !checked.checked });
    formik.setFieldValue("isKidsAllowed", !formik.values.isKidsAllowed);
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = formik.values.photos;
    let newData = e;
    let mergedData = oldData.concat(newData);
    formik.setFieldValue("photos", mergedData);
    if (thumbnail) {
      let thumbData = formik.values?.photo_thumbnails;
      let url = e.split("/");
      url.splice(url.length - 1, 0, "thumbnail");
      url = url.join("/");
      thumbData = thumbData.concat(url);
      formik.setFieldValue("photo_thumbnails", thumbData);
    }
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };
  const cancelFiles = (file) => {
    let restaurant_pictures_temp = formik.values.photos;
    let newToUpload = restaurant_pictures_temp.filter((item) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };
  const bankUploadMultipleFiles = (e) => {
    if (formik.values.photos.length + e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload  more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name;
      if (props.onboarding.restaurant_name) {
        restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      } else {
        restaurant_name = "";
      }
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        let allPicures = formik.values.photos;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        if (docs) {
          axios
            .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
            .then((res) => {
              let oldData = formik.values.photos;
              let newData = res.data;
              let mergedData = oldData.concat(newData);
              formik.setFieldValue("photos", mergedData);
              Alert.success(`<h4>Image Upload Successfully</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            })
            .catch((err) => {
              Alert.error(`<h4>${err}</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            });
        }
      } else {
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formik.values.photos.filter((item, index) => {
      return index !== indexId;
    });
    let thumbImage = formik.values.photo_thumbnails.filter((item, index) => {
      return index !== indexId;
    });
    formik.setFieldValue("photos", allImages);
    formik.setFieldValue("photo_thumbnails", thumbImage);
  };

  // const onCompleteUploadMultipleCrop = (e) => {
  //   let oldData = state.restaurant_pictures;
  //   oldData.push(e);
  //   setState({
  //     ...state,
  //     restaurant_pictures: oldData,
  //     actionButton: true,
  //   });
  // };

  // const uploadMultipleFiles = (e) => {
  //   // setState({ multipleImageLoader: true });
  //   const vendor_id = props.auth.user.VendorUser._id;
  //   const restaurant_name = props.onboarding.restaurant_name
  //     .split(" ")
  //     .join("");
  //   const combined = vendor_id + "_" + restaurant_name;
  //   const data = new FormData();
  //   let flag = false;
  //   var newUploaded = [];
  //   for (let i = 0; i < e.target.files.length; i++) {
  //     if (e.target.files[i].size > imageUploadSize) {
  //       alert("File is too Big");
  //       return (flag = false);
  //     } else if (e.target.files.length > 10) {
  //       alert("You can upload only 10 files");
  //       return (flag = false);
  //     } else {
  //       let allPicures = state.restaurant_pictures;
  //       allPicures.some((phone) => {
  //         if (
  //           phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
  //         ) {
  //           // flag = true;
  //           return (flag = true);
  //         } else {
  //           return (flag = false);
  //         }
  //       });
  //       if (!flag) {
  //         newUploaded.push(e.target.files[i]);
  //         data.append("files", e.target.files[i]);
  //       }
  //     }
  //   }
  //   if (!flag) {
  //     setState({
  //       ...state,
  //       restaurant_pictures_new: newUploaded,
  //       combined: combined,
  //     });
  //   } else {
  //     Alert.error(`<h4>Can not upload the same image</h4>`, {
  //       position: "top-right",
  //       effect: "bouncyflip",
  //       beep: true,
  //       html: true,
  //       timeout: 3000,
  //       offset: 35,
  //     });
  //   }
  //   e.target.value = "";
  // };

  // const multipleResetFile = (indexId) => {
  //   let allPicures = state.restaurant_pictures;
  //   let allPicuresObj = allPicures.find((images, index) => index === indexId);
  //   if (allPicuresObj === 0 || allPicuresObj) {
  //     allPicures.splice(allPicures.indexOf(allPicuresObj), 1);
  //     setState({ ...state, allPicures: allPicures, actionButton: true });
  //   }
  // };

  /*************************************
   * @DESC Multiple Video Upload
   ************************************/
  const uploadMultipleVideoFiles = (e) => {
    e.preventDefault();
    // setState({ multipleImageLoader: true });
    const vendor_id = props.auth.user.VendorUser._id;
    const restaurant_name = props.onboarding.restaurant_name
      .split(" ")
      .join("");
    const combined = vendor_id + "_" + restaurant_name;
    const data = new FormData();
    let flag = false;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size > videoUploadSize) {
        alert("File is too Big");
        return (flag = false);
      } else {
        if (state.restaurant_video && state.restaurant_video.length > 0) {
          if (state.restaurant_video[0].name === e.target.files[i].name) {
            return (flag = true);
          }
        }
        if (!flag) {
          data.append("file", e.target.files[i]);
        }
      }
    }
    // ?uploadSide=${combined}
    var newData = e.target.files;
    if (!flag) {
      const setProgress = (percent) => {
        setState({ ...state, progress: percent });
      };
      axios
        .post(`${serverApi}/upload-assets-video`, data, {
          onUploadProgress: (progressEvent) => {
            setProgress((progressEvent.loaded / progressEvent.total) * 100);
          },
        })
        .then((res) => {
          setState({
            ...state,
            restaurant_video: newData,
            // multipleImageLoader: false,
            video_url: res.data,
            actionButton: true,
          });
          Alert.success(`<h4>Restaurant Video Upload Successfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        })
        .catch((err) => {
          // setState({ multipleImageLoader: false });
          Alert.error(`<h4>${err}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        });
    } else {
      // setState({ multipleImageLoader: false });
      Alert.error(`<h4>Can not upload the same video</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  const multipleVideoResetFile = (e) => {
    let video_url = state.video_url;
    let restaurant_video = state.restaurant_video;
    video_url = "";
    restaurant_video = [];
    setState({
      ...state,
      restaurant_video: restaurant_video,
      video_url: video_url,
      actionButton: true,
    });
  };

  useEffect(() => {
    if (history.location && history.location.state) {
      setEditData(history.location.state.editData);
    }
  }, [history.location && history.location.state]);

  const [editData, setEditData] = useState({});

  const onFocusOutLink = (e) => {
    const { errors } = state;
    if (e.target.value === "") {
      errors[
        e.target.name
      ] = `*Fields can’t be blank. Please enter your ${e.target.name}`;
    } else {
      delete errors[e.target.name];
    }
    setState({
      ...state,
      errors: errors,
      error: Object.keys(errors).length > 0 ? true : false,
      actionButton: true,
    });
  };

  const casualDiningInsideOfflineEventHandler = (type) => (e) => {
    if (type === "eventLinkCodes") {
      setState({
        ...state,
        // link_code_different: !state.link_code_different,
        // link_code_same: !state.link_code_same,
        link_code_same: true,
        casualDiningOnlineEventsYoutube: false,
        casualDiningOnlineEventsInstagram: false,
        casualDiningOnlineEventsFacebook: false,
        casualDiningOnlineEventsLinkdin: false,
        casualDiningOnlineEventsOthers: false,
        casualDiningOnlineEventsYoutubeArr: [],
        casualDiningOnlineEventsInstagramArr: [],
        casualDiningOnlineEventsFacebookArr: [],
        casualDiningOnlineEventsLinkdinArr: [],
        casualDiningOnlineEventsOthersArr: [],
      });
    } else if (type === "eventSameLinkCode") {
      setState({
        ...state,
        link_code_different: !state.link_code_different,
        // link_code_same: !state.link_code_same,
      });
    } else if (type === "eventYoutubeLink") {
      setState({
        ...state,
        casualDiningOnlineEventsYoutube: !state.casualDiningOnlineEventsYoutube,
        casualDiningOnlineEventsYoutubeArr: [
          {
            url: "",
            code: "",
          },
        ],
      });
    } else if (type === "eventInstagramLink") {
      setState({
        ...state,
        casualDiningOnlineEventsInstagram:
          !state.casualDiningOnlineEventsInstagram,
        casualDiningOnlineEventsInstagramArr: [
          {
            url: "",
            code: "",
          },
        ],
      });
    } else if (type === "eventFacebookLink") {
      setState({
        ...state,
        casualDiningOnlineEventsFacebook:
          !state.casualDiningOnlineEventsFacebook,
        casualDiningOnlineEventsFacebookArr: [
          {
            url: "",
            code: "",
          },
        ],
      });
    } else if (type === "eventLinkdinLink") {
      setState({
        ...state,
        casualDiningOnlineEventsLinkdin: !state.casualDiningOnlineEventsLinkdin,
        casualDiningOnlineEventsLinkdinArr: [
          {
            url: "",
            code: "",
          },
        ],
      });
    } else if (type === "eventOthersLink") {
      setState({
        ...state,
        casualDiningOnlineEventsOthers: !state.casualDiningOnlineEventsOthers,
        casualDiningOnlineEventsOthersArr: [
          {
            url: "",
            code: "",
          },
        ],
      });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Youtube Handlers
   ******************************************/
  const onAddYoutubeHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsYoutubeArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].code === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.code = `*Fields can’t be blank. Please enter your code`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        code: "",
      });
      setState({
        ...state,
        casualDiningOnlineEventsYoutubeArr: linkDesc,
      });
    }
  };

  const onYoutubeChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualDiningOnlineEventsYoutubeArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "code") {
      linkDesc[index].code = e.target.value;
    }
    setState({
      ...state,
      casualDiningOnlineEventsYoutubeArr: linkDesc,
    });
  };

  const onYoutubeDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsYoutubeArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualDiningOnlineEventsYoutubeArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Instagram Handlers
   ******************************************/
  const onAddInstagramHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsInstagramArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].code === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.code = `*Fields can’t be blank. Please enter your code`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        code: "",
      });
      setState({
        ...state,
        casualDiningOnlineEventsInstagramArr: linkDesc,
      });
    }
  };

  const onInstagramChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualDiningOnlineEventsInstagramArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "code") {
      linkDesc[index].code = e.target.value;
    }
    setState({
      ...state,
      casualDiningOnlineEventsInstagramArr: linkDesc,
    });
  };

  const onInstagramDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsInstagramArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualDiningOnlineEventsInstagramArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Facebook Handlers
   ******************************************/
  const onAddFacebookHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsFacebookArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].code === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.code = `*Fields can’t be blank. Please enter your code`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        code: "",
      });
      setState({
        ...state,
        casualDiningOnlineEventsFacebookArr: linkDesc,
      });
    }
  };

  const onFacebookChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualDiningOnlineEventsFacebookArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "code") {
      linkDesc[index].code = e.target.value;
    }
    setState({
      ...state,
      casualDiningOnlineEventsFacebookArr: linkDesc,
    });
  };

  const onFacebookDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsFacebookArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualDiningOnlineEventsFacebookArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Linkedin Handlers
   ******************************************/
  const onAddLinkdinHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsLinkdinArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].code === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.code = `*Fields can’t be blank. Please enter your code`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        code: "",
      });
      setState({
        ...state,
        casualDiningOnlineEventsLinkdinArr: linkDesc,
      });
    }
  };

  const onLinkdinChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualDiningOnlineEventsLinkdinArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "code") {
      linkDesc[index].code = e.target.value;
    }
    setState({
      ...state,
      casualDiningOnlineEventsLinkdinArr: linkDesc,
    });
  };

  const onLinkdinDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsLinkdinArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualDiningOnlineEventsLinkdinArr: linkDesc });
    }
  };

  /*****************************************
   * @DESC - Multiple Add Others Handlers
   ******************************************/
  const onAddOthersHandler = (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsOthersArr;
    if (linkDesc.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      linkDesc[linkDesc.length - 1].url === "" ||
      linkDesc[linkDesc.length - 1].code === ""
    ) {
      const { errors } = state;
      if (e.target.value === "") {
        errors.url = `*Fields can’t be blank. Please enter your url`;
        errors.code = `*Fields can’t be blank. Please enter your code`;
      } else {
        delete errors[e.target.name];
        setState({ ...state, errors: {} });
      }
      setState({
        ...state,
        errors: errors,
      });
    } else {
      linkDesc.push({
        url: "",
        code: "",
      });
      setState({
        ...state,
        casualDiningOnlineEventsOthersArr: linkDesc,
      });
    }
  };

  const onOthersChangeHandler = (type, index) => (e) => {
    let linkDesc = state.casualDiningOnlineEventsOthersArr;
    if (type === "link") {
      linkDesc[index].url = e.target.value;
    } else if (type === "code") {
      linkDesc[index].code = e.target.value;
    }
    setState({
      ...state,
      casualDiningOnlineEventsOthersArr: linkDesc,
    });
  };

  const onOthersDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let linkDesc = state.casualDiningOnlineEventsOthersArr;
    if (linkDesc.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      linkDesc.splice(index, 1);
      setState({ ...state, casualDiningOnlineEventsOthersArr: linkDesc });
    }
  };

  useEffect(() => {
    if (editData?.photos) {
      formik.setFieldValue("photos", editData?.photos);
    }
    if (editData?.photo_thumbnails) {
      formik.setFieldValue("photo_thumbnails", editData?.photo_thumbnails);
    }
    if (editData.name) {
      formik.setFieldValue("name", editData.name);
    }
    if (editData.description) {
      formik.setFieldValue("description", editData.description);
    }
    if (editData.coupon_code) {
      formik.setFieldValue("coupon_code", editData.coupon_code);
    }
    if (editData.terms_and_condition) {
      formik.setFieldValue("terms_and_condition", editData.terms_and_condition);
    }
    if (editData.videos && editData.photos && editData._id) {
      setState({
        ...state,
        restaurant_pictures: !isEmpty(editData.photos) ? editData.photos : [],
        video_url: !isEmpty(editData.videos) ? editData.videos : "",
      });
    }
    if (editData.mark_as_primary) {
      setPrimaryOffer({ primaryOffer: editData.mark_as_primary });
    }
    if (editData.active) {
      setactive({ active: editData.active });
    }
    if (editData.start_date) {
      let startD = editData.start_date.split("T")[0];
      formik.setFieldValue(`start_date`, startD);
      let startT = moment(editData.start_date).format("HH:mm");
      formik.setFieldValue(`start_time`, startT);
    }
    if (editData.end_date) {
      let endD = editData.end_date.split("T")[0];
      formik.setFieldValue(`end_date`, endD);
      let endT = moment(editData.end_date).format("HH:mm");
      formik.setFieldValue(`end_time`, endT);
    }
    if (editData.eventLink) {
      formik.setFieldValue("eventLink", editData.eventLink);
    }
    if (editData.eventPassword) {
      formik.setFieldValue("eventPassword", editData.eventPassword);
    }
    formik.setFieldValue("isKidsAllowed", editData.isKidsAllowed);
    formik.setFieldValue("minAge", editData.minAge);

    setState({
      ...state,
      link_code_different: editData.link_code_different,
      link_code_same: editData.link_code_same,
      casualDiningOnlineEventsYoutube: editData.youtube?.value,
      casualDiningOnlineEventsInstagram: editData.instagram?.value,
      casualDiningOnlineEventsFacebook: editData.facebook?.value,
      casualDiningOnlineEventsLinkdin: editData.linkedin?.value,
      casualDiningOnlineEventsOthers: editData.other?.value,
      casualDiningOnlineEventsYoutubeArr: editData.youtube?.sub_values,
      casualDiningOnlineEventsInstagramArr: editData.instagram?.sub_values,
      casualDiningOnlineEventsFacebookArr: editData.facebook?.sub_values,
      casualDiningOnlineEventsLinkdinArr: editData.linkedin?.sub_values,
      casualDiningOnlineEventsOthersArr: editData.other?.sub_values,
    });
  }, [editData]);

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      mark_as_primary: false,
      active: false,
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      isKidsAllowed: false,
      minAge: 18,
      //vendor_id: "5f8ac1f8c0aac52d42af60a8",
      isOnline: true,
      eventLink: "",
      eventPassword: "",
      photos: [],
      photo_thumbnails: [],
      videos: [],
      terms_and_condition: "",

      link_code_different: false,
      link_code_same: false,
      youtube: {
        value: false,
        sub_values: [],
      },
      instagram: {
        value: false,
        sub_values: [],
      },
      facebook: {
        value: false,
        sub_values: [],
      },
      linkedin: {
        value: false,
        sub_values: [],
      },
      other: {
        value: false,
        sub_values: [],
      },
    },
    validationSchema,

    onSubmit: (values) => {
      const startDate = {
        start_date: moment(
          values.start_date + "T" + values.start_time
        ).valueOf(),
      };
      const end_Date = {
        end_date: moment(values.end_date + "T" + values.end_time).valueOf(),
      };

      values.start = startDate.start_date;
      values.end = end_Date.end_date;
      values.vendor_id = props.auth.user.VendorUser._id;

      if (values.isKidsAllowed) {
        values.minAge = "";
      }

      if (primaryOffer.primaryOffer) {
        values.mark_as_primary = true;
      }
      if (active.active) {
        values.active = true;
      }

      const token = !isEmpty(props.auth.user.accessToken)
        ? props.auth.user.accessToken
        : "";
      const offerId = editData._id;
      const formData = {
        name: values.name,
        description: values.description,
        mark_as_primary: values.mark_as_primary,
        start_date: values.start,
        end_date: values.end,
        photos: state.restaurant_pictures,
        photos: formik.values.photos,
        photo_thumbnails: formik.values.photo_thumbnails,
        terms_and_condition: values.terms_and_condition,
        active: values.active,
        venue_address: "",
        vendor_id: values.vendor_id,
        isOnline: true,
        isKidsAllowed: values.isKidsAllowed,
        minAge: values.minAge,
        // eventLink: values.eventLink,
        // eventPassword: values.eventPassword,
        videos: state.video_url === "" ? [] : state.video_url,
        point_of_entry: "VENDOR",

        link_code_different: state.link_code_different,
        link_code_same: state.link_code_same,
        youtube: {
          value: state.casualDiningOnlineEventsYoutube,
          sub_values: state.casualDiningOnlineEventsYoutubeArr,
        },
        instagram: {
          value: state.casualDiningOnlineEventsInstagram,
          sub_values: state.casualDiningOnlineEventsInstagramArr,
        },
        facebook: {
          value: state.casualDiningOnlineEventsFacebook,
          sub_values: state.casualDiningOnlineEventsFacebookArr,
        },
        linkedin: {
          value: state.casualDiningOnlineEventsLinkdin,
          sub_values: state.casualDiningOnlineEventsLinkdinArr,
        },
        other: {
          value: state.casualDiningOnlineEventsOthers,
          sub_values: state.casualDiningOnlineEventsOthersArr,
        },
      };
      props.vendor_update_events(formData, offerId, token, onEventSuccess);
    },
  });

  const onEventSuccess = (e) => {
    Alert.success("<h4>Event Update Successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/event");
  };

  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  const handleStartDateChange = (e) => {
    formik.setFieldValue("start_date", e.target.value);
    formik.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };
  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);

  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  // useEffect(() => {
  //   formik.setFieldValue("name", "");
  // }, []);

  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let nameElement = document.getElementById("name");
      nameElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    } else if (formik.errors && formik.errors.start_date) {
      let startDateElement = document.getElementById("start_date");
      startDateElement.focus();
    } else if (formik.errors && formik.errors.start_time) {
      let startTimeElement = document.getElementById("start_time");
      startTimeElement.focus();
    } else if (formik.errors && formik.errors.end_time) {
      let endDateElement = document.getElementById("end_time");
      endDateElement.focus();
    } else if (formik.errors && formik.errors.end_date) {
      let endTimeElement = document.getElementById("end_date");
      endTimeElement.focus();
    }
    //  else if (formik.errors && formik.errors.eventLink) {
    //   let eventLinkElement = document.getElementById("eventLink");
    //   eventLinkElement.focus();
    // }
    else if (formik.errors && formik.errors.terms_and_condition) {
      let termAndCondtionsElement = document.getElementById(
        "terms_and_condition"
      );
      termAndCondtionsElement.focus();
    }
  }, [count]);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={2} />
          </div>
          <div className="super-admin-right-side-panel">
            <div className="super-admin-inside-right-side-panel">
              <RightSideNavigation />
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Edit Event</div>
              </div>
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f20_700_HelveticaNeue">Event Type</div>
              </div>
              <div className="d-flex align-items-start">
                <div className={`enAddOffersOPtion `}>
                  <Image
                    src={require("../../../../assets/images/UserManagement/onlineActiveOffer.svg")}
                    alt="View"
                    title="View"
                    fluid
                    className="ml-3"
                  />
                  <span className="text-red f12-400 d-block w-100 mb-2">
                    Online Event
                  </span>
                  <span className="w-100 f9-400 d-block">
                    (Note: these offers can be only be used in your business
                    location offline)
                  </span>
                </div>
              </div>
              <hr />
              <Form>
                <Row className="pt-4">
                  <Col lg={8}>
                    <Form.Group>
                      <TextField
                        id="name"
                        label="Event Name"
                        type="text"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.name && formik.touched.name
                            ? "enError"
                            : ""
                        }`}
                        name="name"
                        onChange={formik.handleChange}
                        value={formik.values.name}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.name && formik.touched.name ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.name}
                        </div>
                      ) : null}
                    </Form.Group>
                    <Form.Group>
                      <TextField
                        id="description"
                        label="Description"
                        type="text"
                        multiline
                        rows="5"
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.description &&
                          formik.touched.description
                            ? "enError"
                            : ""
                        }`}
                        name="description"
                        onChange={formik.handleChange}
                        value={formik.values.description}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.description &&
                      formik.touched.description ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.description}
                        </div>
                      ) : null}
                    </Form.Group>
                    <Row className="pb-4">
                      <Col lg={6}>
                        <div className="f12-400">
                          (Fill out the details, event are used offline)
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="d-flex align-items-start">
                          <Switch
                            onChange={markAsPrimary(primaryOffer.primaryOffer)}
                            checked={primaryOffer.primaryOffer}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={24}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={15}
                            width={41}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                          <div className="pl-2">
                            <div className="f12-500 mb-2">
                              Make this Event Primary
                            </div>
                            <div className="f10-400">
                              (Note you can make only one Offer primary, by
                              making this offer primary it will remove primary
                              from other active offers)
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr />
                    <Row className="pb-4">
                      <Col lg={2}>
                        <div className="f16-500">Status</div>
                      </Col>
                      <Col lg={3} className="d-flex">
                        <div
                          className={`${
                            active.active === false ? "f14-500" : "f14-400"
                          }`}
                        >
                          InActive
                        </div>
                        <div className="d-flex align-items-start ml-2 mr-2">
                          <Switch
                            onChange={statusChange}
                            checked={active.active}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={24}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={15}
                            width={41}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                        </div>
                        <div
                          className={`${active.active ? "f14-500" : "f14-400"}`}
                        >
                          Active
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={12}>
                    <hr />

                    <div className="f16-500 py-1">Allow Kids?</div>
                    <div className="f10-400 pb-4">
                      (This may be relevant if you are a Bar and Night Club with
                      min age to enter, you may still have to check the ID for
                      the entrants)
                    </div>
                    <Row className="align-items-center pb-3">
                      <Col md={3}>
                        <div className="f14-400 text-dark">Kids Allowed</div>
                      </Col>
                      <Col md={9}>
                        <div className="d-flex align-items-center">
                          <div className="f12-400 mr-2">No</div>
                          <Toggle
                            checked={formik.values.isKidsAllowed}
                            toggleFunction={toggleFunction}
                          />
                          <div className="f12-400 ml-2">Yes</div>
                        </div>
                      </Col>
                    </Row>
                    {formik.values.isKidsAllowed ? (
                      <></>
                    ) : (
                      <Row className="align-items-center pb-3">
                        <Col md={3}>
                          <div className="f14-400 text-dark">
                            Min Age for Entry
                          </div>
                        </Col>
                        <Col md={9}>
                          <FormControl variant="outlined" className={"w134"}>
                            <Select
                              value={formik.values.minAge}
                              onChange={formik.handleChange}
                              inputProps={{
                                name: "minAge",
                                type: "number",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <option value={"Select Age"} selected>
                                Select Age
                              </option>
                              <option value={18}>18</option>
                              <option value={21}>21</option>
                            </Select>
                          </FormControl>
                        </Col>
                      </Row>
                    )}
                    <hr className="mb-5" />
                    <Row className="pb-4 align-items-center">
                      <Col md={3} xl={2}>
                        <TextField
                          id="start_date"
                          label="Start Date"
                          variant="outlined"
                          InputProps={{
                            inputProps: { min: minDate },
                          }}
                          type="date"
                          defaultValue={minDate}
                          className={`w-100 ${
                            formik.errors.start_date &&
                            formik.touched.start_date
                              ? "enError"
                              : ""
                          }`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="start_date"
                          onChange={(e) => handleStartDateChange(e)}
                          //onChange={formik.handleChange}
                          value={formik.values.start_date}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.start_date &&
                        formik.touched.start_date ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.start_date}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={3} xl={2}>
                        <TextField
                          id="start_time"
                          label="Start Time"
                          variant="outlined"
                          type="time"
                          className={`w-100 ${
                            formik.errors.start_time &&
                            formik.touched.start_time
                              ? "enError"
                              : ""
                          }`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="start_time"
                          onChange={formik.handleChange}
                          value={formik.values.start_time}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.start_time &&
                        formik.touched.start_time ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.start_time}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={3} xl={2}>
                        <TextField
                          id="end_date"
                          label="End Date"
                          variant="outlined"
                          InputProps={{
                            inputProps: { min: minEndDate },
                          }}
                          type="date"
                          className={`w-100 ${
                            formik.errors.end_date && formik.touched.end_date
                              ? "enError"
                              : ""
                          }`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="end_date"
                          onChange={formik.handleChange}
                          value={formik.values.end_date}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.end_date && formik.touched.end_date ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.end_date}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={3} xl={2}>
                        <TextField
                          id="end_time"
                          label="End Time"
                          variant="outlined"
                          type="time"
                          className={`w-100 ${
                            formik.errors.end_time && formik.touched.end_time
                              ? "enError"
                              : ""
                          }`}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="end_time"
                          onChange={formik.handleChange}
                          value={formik.values.end_time}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.end_time && formik.touched.end_time ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.end_time}
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                    <React.Fragment>
                      <div className="row margin-between-toggler inside-event-offline-online-text mb-3">
                        <div className="col-4">
                          <div className="f14-500">Youtube</div>
                          <div className="f10-400 opacity5">
                            Enter your hyperlink and joining code information
                            for event below
                          </div>
                        </div>
                        <div className="col-4">
                          <Switch
                            checked={state.casualDiningOnlineEventsYoutube}
                            onChange={casualDiningInsideOfflineEventHandler(
                              "eventYoutubeLink"
                            )}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={16}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={10}
                            width={27}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                        </div>
                      </div>
                      {state.casualDiningOnlineEventsYoutube ? (
                        <React.Fragment>
                          {state.casualDiningOnlineEventsYoutubeArr.map(
                            (data, index) => (
                              <div
                                className="row inside-event-offline-online-text mb-5"
                                key={index}
                              >
                                <div className="col-4">
                                  <div className="row mt-3">
                                    <Col md={12} className="mb-2">
                                      <NewInputText
                                        extraClass="mb-1"
                                        name="url"
                                        inputType="text"
                                        onFocusOut={onFocusOutLink}
                                        onChange={onYoutubeChangeHandler(
                                          "link",
                                          index
                                        )}
                                        maxLength="50"
                                        value={data.url}
                                        labelText="Hyperlink"
                                        errorText={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? "*Fields can’t be blank. Please enter your Stream URL"
                                            : null
                                        }
                                        errorTrue={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? true
                                            : false
                                        }
                                        controlClass={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? "outlined-error-helper-text"
                                            : "outlined-helperText "
                                        }
                                      />
                                    </Col>
                                    <Col md={12}>
                                      <NewInputText
                                        extraClass="mb-1"
                                        name="code"
                                        inputType="text"
                                        onFocusOut={onFocusOutLink}
                                        onChange={onYoutubeChangeHandler(
                                          "code",
                                          index
                                        )}
                                        maxLength="50"
                                        value={data.code}
                                        labelText="Joining Code or Password(if any)"
                                        errorText={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? "*Fields can’t be blank. Please enter your Event Code"
                                            : null
                                        }
                                        errorTrue={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? true
                                            : false
                                        }
                                        controlClass={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? "outlined-error-helper-text"
                                            : "outlined-helperText "
                                        }
                                      />
                                    </Col>
                                    {state.casualDiningOnlineEventsYoutubeArr
                                      .length > 1 ? (
                                      <div className="col-2 restaurant_details_onboarding_minus_button align-items-start pt-2">
                                        <div>
                                          <AddButtonIconComponent
                                            buttonText="Delete"
                                            onClick={onYoutubeDeleteHandler(
                                              index
                                            )}
                                            fontIcon="fa fa-trash-o"
                                            colorCss="delete"
                                          />
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                          {state.link_code_different !== true ? (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add another streaming link for different area"
                                onClick={onAddYoutubeHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          <hr />
                        </React.Fragment>
                      ) : null}

                      <div className="row margin-between-toggler inside-event-offline-online-text mb-3">
                        <div className="col-4">
                          <div className="f14-500">Instagram</div>
                          <div className="f10-400 opacity5">
                            Enter your hyperlink and joining code information
                            for event below
                          </div>
                        </div>
                        <div className="col-4">
                          <Switch
                            checked={state.casualDiningOnlineEventsInstagram}
                            onChange={casualDiningInsideOfflineEventHandler(
                              "eventInstagramLink"
                            )}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={16}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={10}
                            width={27}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                        </div>
                      </div>
                      {state.casualDiningOnlineEventsInstagram ? (
                        <React.Fragment>
                          {state.casualDiningOnlineEventsInstagramArr.map(
                            (data, index) => (
                              <div
                                className="row inside-event-offline-online-text mb-5"
                                key={index}
                              >
                                <div className="col-4">
                                  <div className="row mt-3">
                                    <Col md={12} className="mb-2">
                                      <NewInputText
                                        extraClass="mb-1"
                                        name="url"
                                        inputType="text"
                                        onFocusOut={onFocusOutLink}
                                        onChange={onInstagramChangeHandler(
                                          "link",
                                          index
                                        )}
                                        maxLength="50"
                                        value={data.url}
                                        labelText="Hyperlink"
                                        errorText={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? "*Fields can’t be blank. Please enter your Stream URL"
                                            : null
                                        }
                                        errorTrue={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? true
                                            : false
                                        }
                                        controlClass={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? "outlined-error-helper-text"
                                            : "outlined-helperText "
                                        }
                                      />
                                    </Col>
                                    <Col md={12}>
                                      <NewInputText
                                        extraClass="mb-1"
                                        name="code"
                                        inputType="text"
                                        onFocusOut={onFocusOutLink}
                                        onChange={onInstagramChangeHandler(
                                          "code",
                                          index
                                        )}
                                        maxLength="50"
                                        value={data.code}
                                        labelText="Joining Code or Password(if any)"
                                        errorText={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? "*Fields can’t be blank. Please enter your Event Code"
                                            : null
                                        }
                                        errorTrue={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? true
                                            : false
                                        }
                                        controlClass={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? "outlined-error-helper-text"
                                            : "outlined-helperText "
                                        }
                                      />
                                    </Col>
                                  </div>
                                </div>
                                {state.casualDiningOnlineEventsInstagramArr
                                  .length > 1 ? (
                                  <div className="col-2 restaurant_details_onboarding_minus_button">
                                    <div>
                                      <AddButtonIconComponent
                                        buttonText="Delete"
                                        onClick={onInstagramDeleteHandler(
                                          index
                                        )}
                                        fontIcon="fa fa-trash-o"
                                        colorCss="delete"
                                      />
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )
                          )}
                          {state.link_code_different !== true ? (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add another streaming link for different area"
                                onClick={onAddInstagramHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          <hr />
                        </React.Fragment>
                      ) : null}

                      <div className="row margin-between-toggler inside-event-offline-online-text mb-3">
                        <div className="col-4">
                          <div className="f14-500">Facebook</div>
                          <div className="f10-400 opacity5">
                            Enter your hyperlink and joining code information
                            for event below
                          </div>
                        </div>
                        <div className="col-4">
                          <Switch
                            checked={state.casualDiningOnlineEventsFacebook}
                            onChange={casualDiningInsideOfflineEventHandler(
                              "eventFacebookLink"
                            )}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={16}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={10}
                            width={27}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                        </div>
                      </div>
                      {state.casualDiningOnlineEventsFacebook ? (
                        <React.Fragment>
                          {state.casualDiningOnlineEventsFacebookArr.map(
                            (data, index) => (
                              <div
                                className="row inside-event-offline-online-text mb-5"
                                key={index}
                              >
                                <div className="col-4">
                                  <div className="row mt-3">
                                    <Col md={12} className="mb-2">
                                      <NewInputText
                                        extraClass="mb-1"
                                        name="url"
                                        inputType="text"
                                        onFocusOut={onFocusOutLink}
                                        onChange={onFacebookChangeHandler(
                                          "link",
                                          index
                                        )}
                                        maxLength="50"
                                        value={data.url}
                                        labelText="Hyperlink"
                                        errorText={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? "*Fields can’t be blank. Please enter your Stream URL"
                                            : null
                                        }
                                        errorTrue={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? true
                                            : false
                                        }
                                        controlClass={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? "outlined-error-helper-text"
                                            : "outlined-helperText "
                                        }
                                      />
                                    </Col>
                                    <Col md={12} className="mb-2">
                                      <NewInputText
                                        extraClass="mb-1"
                                        name="code"
                                        inputType="text"
                                        onFocusOut={onFocusOutLink}
                                        onChange={onFacebookChangeHandler(
                                          "code",
                                          index
                                        )}
                                        maxLength="50"
                                        value={data.code}
                                        labelText="Joining Code or Password(if any)"
                                        errorText={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? "*Fields can’t be blank. Please enter your Event Code"
                                            : null
                                        }
                                        errorTrue={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? true
                                            : false
                                        }
                                        controlClass={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? "outlined-error-helper-text"
                                            : "outlined-helperText "
                                        }
                                      />
                                    </Col>
                                  </div>
                                </div>
                                {state.casualDiningOnlineEventsFacebookArr
                                  .length > 1 ? (
                                  <div className="col-2 restaurant_details_onboarding_minus_button">
                                    <div>
                                      <AddButtonIconComponent
                                        buttonText="Delete"
                                        onClick={onFacebookDeleteHandler(index)}
                                        fontIcon="fa fa-trash-o"
                                        colorCss="delete"
                                      />
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )
                          )}
                          {state.link_code_different !== true ? (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add another streaming link for different area"
                                onClick={onAddFacebookHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          <hr />
                        </React.Fragment>
                      ) : null}

                      <div className="row margin-between-toggler inside-event-offline-online-text mb-3">
                        <div className="col-4">
                          <div className="f14-500">Linkedin</div>
                          <div className="f10-400 opacity5">
                            Enter your hyperlink and joining code information
                            for event below
                          </div>
                        </div>
                        <div className="col-4">
                          <Switch
                            checked={state.casualDiningOnlineEventsLinkdin}
                            onChange={casualDiningInsideOfflineEventHandler(
                              "eventLinkdinLink"
                            )}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={16}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={10}
                            width={27}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                        </div>
                      </div>
                      {state.casualDiningOnlineEventsLinkdin ? (
                        <React.Fragment>
                          {state.casualDiningOnlineEventsLinkdinArr.map(
                            (data, index) => (
                              <div
                                className="row inside-event-offline-online-text mb-5"
                                key={index}
                              >
                                <div className="col-4">
                                  <div className="row mt-3">
                                    <Col md={12} className="mb-2">
                                      <NewInputText
                                        extraClass="mb-1"
                                        name="url"
                                        inputType="text"
                                        onFocusOut={onFocusOutLink}
                                        onChange={onLinkdinChangeHandler(
                                          "link",
                                          index
                                        )}
                                        maxLength="50"
                                        value={data.url}
                                        labelText="Hyperlink"
                                        errorText={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? "*Fields can’t be blank. Please enter your Stream URL"
                                            : null
                                        }
                                        errorTrue={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? true
                                            : false
                                        }
                                        controlClass={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? "outlined-error-helper-text"
                                            : "outlined-helperText "
                                        }
                                      />
                                    </Col>
                                    <Col md={12} className="mb-2">
                                      <NewInputText
                                        extraClass="mb-1"
                                        name="code"
                                        inputType="text"
                                        onFocusOut={onFocusOutLink}
                                        onChange={onLinkdinChangeHandler(
                                          "code",
                                          index
                                        )}
                                        maxLength="50"
                                        value={data.code}
                                        labelText="Joining Code or Password(if any)"
                                        errorText={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? "*Fields can’t be blank. Please enter your Event Code"
                                            : null
                                        }
                                        errorTrue={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? true
                                            : false
                                        }
                                        controlClass={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? "outlined-error-helper-text"
                                            : "outlined-helperText "
                                        }
                                      />
                                    </Col>
                                  </div>
                                </div>
                                {state.casualDiningOnlineEventsLinkdinArr
                                  .length > 1 ? (
                                  <div className="col-2 restaurant_details_onboarding_minus_button">
                                    <div>
                                      <AddButtonIconComponent
                                        buttonText="Delete"
                                        onClick={onLinkdinDeleteHandler(index)}
                                        fontIcon="fa fa-trash-o"
                                        colorCss="delete"
                                      />
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )
                          )}
                          {state.link_code_different !== true ? (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add another streaming link for different area"
                                onClick={onAddLinkdinHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          <hr />
                        </React.Fragment>
                      ) : null}

                      <div className="row margin-between-toggler inside-event-offline-online-text mb-3">
                        <div className="col-4">
                          <div className="f14-500">Others</div>
                          <div className="f10-400 opacity5">
                            Enter your hyperlink and joining code information
                            for event below
                          </div>
                        </div>
                        <div className="col-4">
                          <Switch
                            checked={state.casualDiningOnlineEventsOthers}
                            onChange={casualDiningInsideOfflineEventHandler(
                              "eventOthersLink"
                            )}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={16}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={10}
                            width={27}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                        </div>
                      </div>
                      {state.casualDiningOnlineEventsOthers ? (
                        <React.Fragment>
                          {state.casualDiningOnlineEventsOthersArr.map(
                            (data, index) => (
                              <div
                                className="row inside-event-offline-online-text mb-5"
                                key={index}
                              >
                                <div className="col-4">
                                  <div className="row mt-3">
                                    <Col md={12} className="mb-2">
                                      <NewInputText
                                        extraClass="mb-1"
                                        name="url"
                                        inputType="text"
                                        onFocusOut={onFocusOutLink}
                                        onChange={onOthersChangeHandler(
                                          "link",
                                          index
                                        )}
                                        maxLength="50"
                                        value={data.url}
                                        labelText="Hyperlink"
                                        errorText={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? "*Fields can’t be blank. Please enter your Stream URL"
                                            : null
                                        }
                                        errorTrue={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? true
                                            : false
                                        }
                                        controlClass={
                                          data.url === "" &&
                                          state.errors.url ===
                                            "*Fields can’t be blank. Please enter your url"
                                            ? "outlined-error-helper-text"
                                            : "outlined-helperText "
                                        }
                                      />
                                    </Col>
                                    <Col md={12} className="mb-2">
                                      <NewInputText
                                        extraClass="mb-1"
                                        name="code"
                                        inputType="text"
                                        onFocusOut={onFocusOutLink}
                                        onChange={onOthersChangeHandler(
                                          "code",
                                          index
                                        )}
                                        maxLength="50"
                                        value={data.code}
                                        labelText="Joining Code or Password(if any)"
                                        errorText={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? "*Fields can’t be blank. Please enter your Event Code"
                                            : null
                                        }
                                        errorTrue={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? true
                                            : false
                                        }
                                        controlClass={
                                          data.code === "" &&
                                          state.errors.code ===
                                            "*Fields can’t be blank. Please enter your code"
                                            ? "outlined-error-helper-text"
                                            : "outlined-helperText "
                                        }
                                      />
                                    </Col>
                                  </div>
                                </div>
                                {state.casualDiningOnlineEventsOthersArr
                                  .length > 1 ? (
                                  <div className="col-2 restaurant_details_onboarding_minus_button">
                                    <div>
                                      <AddButtonIconComponent
                                        buttonText="Delete"
                                        onClick={onOthersDeleteHandler(index)}
                                        fontIcon="fa fa-trash-o"
                                        colorCss="delete"
                                      />
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )
                          )}
                          {state.link_code_different !== true ? (
                            <div>
                              <AddButtonIconComponent
                                buttonText="Add another streaming link for different area"
                                onClick={onAddOthersHandler}
                                fontIcon="fa fa-plus"
                                colorCss="blue"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          <hr />
                        </React.Fragment>
                      ) : null}
                    </React.Fragment>
                    {/* <Row className="pb-4 align-items-center">
              <Col md={4} lg={4}>
                <Form.Group>
                  <TextField
                    label="Coupon Code"
                    type="text"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
            </Row> */}
                    {/* <Row>
                      <Col lg={4} className="pb-4">
                        <Form.Group>
                          <TextField
                            id="eventLink"
                            label="Hyperlink"
                            type="text"
                            variant="outlined"
                            className={`w-100 ${
                              formik.errors.eventLink &&
                              formik.touched.eventLink
                                ? "enError"
                                : ""
                            }`}
                            name="eventLink"
                            onChange={formik.handleChange}
                            value={formik.values.eventLink}
                            onBlur={formik.handleBlur}
                          />
                          {formik.errors.eventLink &&
                          formik.touched.eventLink ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.eventLink}
                            </div>
                          ) : null}
                        </Form.Group>
                      </Col>
                      <Col lg={3} className="pb-4">
                        <Form.Group>
                          <TextField
                            label="Join Code"
                            type="text"
                            variant="outlined"
                            className="w-100"
                            name="eventPassword"
                            onChange={formik.handleChange}
                            value={formik.values.eventPassword}
                          />
                        </Form.Group>
                      </Col>
                    </Row> */}
                    <hr />
                    <div className="event-offer-image">
                      <SimpleReactLightbox>
                        <MultipleImageUploadComponent
                          title="Add Photos*"
                          smallTitle="(Add detail pictures of Business Establishment Images - If needed you can get a professional photo shoot to make it attractive this will appear on user app this will be reviewed periodically )"
                          onChange={bankUploadMultipleFiles}
                          //stateValue={bank_informaion}
                          cancelFiles={cancelFiles}
                          stateValue={formik.values.photos}
                          newUploaded={
                            restaurant_pictures_new
                              ? restaurant_pictures_new
                              : []
                          }
                          combined={combined}
                          onCompleteUploadMultipleCrop={
                            onCompleteUploadMultipleCrop
                          }
                          removeImage={bankDocMultipleRemove}
                          accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                          thumbnail={thumbnail}
                          // onChange={uploadMultipleFiles}
                          // stateValue={
                          //   state.restaurant_pictures &&
                          //   state.restaurant_pictures
                          // }
                          // newUploaded={
                          //   state.restaurant_pictures_new
                          //     ? state.restaurant_pictures_new
                          //     : []
                          // }
                          // combined={state.combined}
                          // onCompleteUploadMultipleCrop={
                          //   onCompleteUploadMultipleCrop
                          // }
                          // removeImage={multipleResetFile}
                          // accept="image/gif,image/jpeg,image/jpg,image/png"
                          // loader={state.multipleImageLoader}
                        />
                        <div className="font_12_r c_gray mb-4 d-flex">
                          (You can add upto 6-10 pictures)
                          {/* <div className="c_red ml-2"> Learn more</div> */}
                        </div>
                      </SimpleReactLightbox>
                    </div>
                    <div className="event-offer-image">
                      <SimpleReactLightbox>
                        <MultipleImageUploadComponent
                          title="Add Video"
                          smallTitle="( Add Videos or 360 view of Business Establishment - If needed you can get a professional photo shoot or video to make it attractive - this will appear on user app)"
                          onChange={uploadMultipleVideoFiles}
                          stateValue={
                            state.video_url === "" ? [] : [state.video_url]
                          }
                          removeImage={multipleVideoResetFile}
                          accept="video/*"
                          singleUpload={true}
                          videoUpload={true}
                          // loader={state.multipleImageLoader}
                        />
                        <div className="font_12_r c_gray mb-4 d-flex">
                          (You can add upto 6 videos){" "}
                          <div className="c_red ml-2">Learn more</div>
                        </div>
                      </SimpleReactLightbox>
                      {!state.progress && state.progress === 0 ? null : (
                        <AlertDialogProgress
                          progress={state.progress}
                          title="Video Uploading..."
                        />
                      )}
                    </div>
                    {/* <Form.Group className="py-4">
                      <Form.Label className="f14-500 mb-3">
                        Add Photos
                      </Form.Label>
                      <div className="d-flex flex-wrap">
                        <div className="enUploadBox">
                          <Image
                            src={require("../../../../assets/images/UserManagement/uploadImg.svg")}
                            alt="uploadImg"
                            title="uploadImg"
                            fluid
                          />
                          <input
                            type="file"
                            accept=".png, .jpg, .jpeg"
                            onChange={(e) => uploadImage(e)}
                          />
                        </div>
                        {file && (
                          <div className="enIconUploaded">
                            <button
                              type="button"
                              className="enCloseButton"
                              onClick={() => removeImage()}
                            >
                              <Image
                                src={require("../../../../assets/images/UserManagement/en_close.svg")}
                                alt="uploadImg"
                                title="uploadImg"
                                fluid
                              />
                            </button>
                            <Image
                              src={file}
                              alt="icon"
                              title="icon"
                              className=""
                              fluid
                            />
                          </div>
                        )}
                      </div>
                      <div className="pt-2 f12-400">
                        (You can upload only 1 pic per offer 700 x 420 pixels)
                      </div>
                    </Form.Group> */}
                    {/* <Form.Group className="pb-4">
                      <Form.Label className="f14-500 mb-3">
                        Add Video
                      </Form.Label>
                      <div className="d-flex flex-wrap">
                        <div className="enUploadBox">
                          <Image
                            src={require("../../../../assets/images/UserManagement/uploadImg.svg")}
                            alt="uploadImg"
                            title="uploadImg"
                            fluid
                          />
                          <input
                            type="file"
                            accept=".mp4"
                            onChange={uploadVideo}
                          />
                        </div>
                        {Video && (
                          <div className="enIconUploaded">
                            <button
                              type="button"
                              className="enCloseButton"
                              onClick={() => removeVideo()}
                            >
                              <Image
                                src={require("../../../../assets/images/UserManagement/en_close.svg")}
                                alt="uploadImg"
                                title="uploadImg"
                                fluid
                              />
                            </button>
                            <video
                              width="100%"
                              height="100%"
                              controls
                              src={Video}
                              type="video/mp4"
                            />
                          </div>
                        )}
                      </div>
                      <div className="pt-2 f12-400">
                        (You can upload only 1 pic per offer 700 x 420 pixels)
                      </div>
                    </Form.Group> */}
                    <Row>
                      <Col lg={8}>
                        <Form.Group>
                          <TextField
                            id="terms_and_condition"
                            label="Terms and Conditions"
                            type="text"
                            multiline
                            rows="5"
                            variant="outlined"
                            className={`w-100 ${
                              formik.errors.terms_and_condition &&
                              formik.touched.terms_and_condition
                                ? "enError"
                                : ""
                            }`}
                            name="terms_and_condition"
                            onChange={formik.handleChange}
                            value={formik.values.terms_and_condition}
                            onBlur={formik.handleBlur}
                          />
                          {formik.errors.terms_and_condition &&
                          formik.touched.terms_and_condition ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.terms_and_condition}
                            </div>
                          ) : null}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="py-4 d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5 btn150px"
                        onClick={() => history.push("/event")}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5 btn150px"
                        onClick={(e) => onClickSave(e)}
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

VendorEditOnlineEvent.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, { vendor_update_events })(
  VendorEditOnlineEvent
);
